import { FC, ReactNode } from 'react';
import clsx from 'clsx';

interface ContentCardProps {
  children: ReactNode;
  className?: string;
}

const ContentCard: FC<ContentCardProps> = ({ children, className }) => {
  return (
    <div className={clsx('bg-white rounded-lg shadow py-4 px-6', className)}>
      {children}
    </div>
  );
};

export default ContentCard;
